import React from 'react'
import System from "../../../../../helper/system";
import Order from "@system/config/order";
import SystemAlerts from 'src/component/SystemAlerts';
import { useOrderStore } from 'src/hooks/order';

const OrderInfoHeader = (props) => {
    const [{ }, { }, { export_order }] = useOrderStore();

    const exportOrder = async () => {
        await export_order({
            "keyword": System.getParams().order_number,
            "searchType": "OrderNumber",
            "filterByOption": [],
            "timeSpan": "",
            "sortBy": "",
            "sortOrder": "",
            "isExportAll": false,
            "isEmail": false
        })
    }
    return (
        <>
            <div className="pcn-page-head header-container d-flex align-items-center justify-sm-content-between flex-wrap flex-sm-nowrap">
                <div className="page-title font-oswald font-light font-30 mb-3 mb-sm-0">Order Details</div>
                <div className="ms-sm-auto mb-0">
                    <ul className="d-flex justify-content-start justify-content-lg-end list-unstyled mb-0">
                        <li className="ms-sm-4"><a
                            href={void (0)} data-toggle="modal" data-target="#EmailSales" onClick={() => {
                                System.popup('OrderDetailEmailSalesPopup', {});
                            }}><i className="fa fa-envelope me-2 text-black" aria-hidden="true"></i> Email</a></li>
                        <li className="ms-4"
                            onClick={() => exportOrder()}>
                            <a><i className="file-export-icon me-2 text-black" aria-hidden="true"></i>Export Order</a></li>
                        <li className="ms-4"><a
                            href={void (0)}
                            onClick={() => {
                                window.print()
                            }}><i className="fa fa-print me-2 text-black"
                            ></i>Print Page</a></li>
                    </ul>
                </div>
            </div>
            <div className="pcn-line-divider mb-2" />
            <SystemAlerts />

            <a href={void (0)} className="return-to-order d-flex align-items-center mb-2"
                onClick={() => {
                    window.location.href = Order.getOrderHistoryRouteURL();
                }}>
                <i className='return-cart me-1'></i><span>Return to Order History</span>
            </a>
        </>
    )
}

export default OrderInfoHeader